var _rect, _rect2, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 240,
    viewBox: "0 0 333 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 327,
    height: 234,
    rx: 37,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 327,
    height: 234,
    rx: 37,
    fill: "url(#paint0_linear_10_3)",
    fillOpacity: 0.12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 327,
    height: 234,
    rx: 37,
    stroke: "url(#paint1_linear_10_3)",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_3",
    x1: 378,
    y1: 313,
    x2: -73.2471,
    y2: 199.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#9845FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F06B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10_3",
    x1: 431.667,
    y1: 357.985,
    x2: 16.811,
    y2: 4.02822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DF8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353256,
    stopColor: "#00D69F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0986FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBackground);
export default __webpack_public_path__ + "static/media/card-background.27baabd26594e7b6ebd4dd61edc280f1.svg";
export { ForwardRef as ReactComponent };